import {
  Component,
  HostBinding,
  ChangeDetectionStrategy,
  Input,
  Output,
  OnInit,
  OnDestroy,
  EventEmitter
} from "@angular/core";
import { UserAliasService } from "@onsip/common/services/api/resources/userAlias/user-alias.service";
import { Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { QueueWithExt } from "../../../acdQueuesPage/acd-queues-page.component";
import { E2eLocators } from "@onsip/e2e/configs/locators";

@Component({
  selector: "onsip-acd-queues-basic-view",
  templateUrl: "./acd-queues-basic-settings-view.component.html",
  styleUrls: ["../acdQueuesBasicSettingsEdit/acd-queues-basic-settings-edit.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AcdQueuesBasicViewComponent implements OnInit, OnDestroy {
  @HostBinding("class.onsip-grid-content")
  @HostBinding("class.onsip-admin-host-grid")
  _dontUse = true;
  @Input() queue!: QueueWithExt;
  @Output() editPanel = new EventEmitter<void>();

  E2eLocators = E2eLocators;
  loginExtensions: Array<string> = [];
  oneColumn = false;
  twoColumn = false;
  threeColumn = false;
  private unsubscriber = new Subscription();

  constructor(private userAlias: UserAliasService) {}

  ngOnInit(): void {
    this.unsubscriber.add(
      this.userAlias.orgState
        .pipe(
          map(aliases => {
            const loginExts = aliases
              .filter(alias => alias.addressUsername === this.queue.username)
              .map(alias => alias.aliasUsername);
            return loginExts;
          })
        )
        .subscribe(loginExts => {
          this.loginExtensions = loginExts;
        })
    );
    this.unsubscriber.add(
      this.userAlias.orgState.subscribe(aliases => {
        this.loginExtensions = aliases
          .filter(alias => alias.addressUsername === this.queue.username)
          .map(alias => alias.aliasUsername);
      })
    );
  }

  ngOnDestroy(): void {
    this.unsubscriber.unsubscribe();
  }

  getLoginExtensions(): string {
    let loginStr = "";
    this.loginExtensions.map(ext => {
      loginStr += ext + "\n";
    });
    return loginStr;
  }

  togglePanel(): void {
    this.editPanel.emit();
  }
}
